/**
 * Copy for the Stock List thank-you page, `pages/stock-list/complete/index.tsx`. `PageContent` is
 * listed in the site search index (`scripts/staticSearch.ts` → `CompleteIndexContent`).
 */
import { StaticPageContent } from "@components/Shared/model/StaticPageContent";
import { LanguageContent } from "@components/Shared/model/LanguageContent";
import { MetaContent } from "@components/Shared/model/MetaHead";
import { StockListThankYouContent } from "@components/StockList/Complete";

/**
 * SEO head for the thank-you page. `url` is `/stock-list/stock-list-thank-you`, a path no page
 * serves (the page is `/stock-list/complete`), so the page's canonical and `og:url`, and its
 * site-search entry, point there. The `fr` and `es` entries repeat the English text.
 */
export const MetaObject: LanguageContent<MetaContent> = {
	en: {
		title: "Stock List - Single-Source Supplier of Metal Products - Ryerson",
		description: `Our stock list is a comprehensive list of the aluminum, steel, stainless steel, and red metal grades that we carry.`,
		url: `/stock-list/stock-list-thank-you`,
		imageUrl: "/images/stock-list/StockBook.jpg",
		company: true,
	},
	fr: {
		title: "Stock List - Single-Source Supplier of Metal Products - Ryerson",
		description: `Our stock list is a comprehensive list of the aluminum, steel, stainless steel, and red metal grades that we carry.`,
		url: `/stock-list/stock-list-thank-you`,
		imageUrl: "/images/stock-list/StockBook.jpg",
		company: true,
	},
	es: {
		title: "Stock List - Single-Source Supplier of Metal Products - Ryerson",
		description: `Our stock list is a comprehensive list of the aluminum, steel, stainless steel, and red metal grades that we carry.`,
		url: `/stock-list/stock-list-thank-you`,
		imageUrl: "/images/stock-list/StockBook.jpg",
		company: true,
	},
};

/**
 * The thank-you heading and text. `description` ends in "contact us: ", and
 * `components/StockList/Complete.tsx` renders the brand's contact email as a `mailto:` link
 * straight after it. English in all three languages.
 */
export const ThankYou: LanguageContent<StockListThankYouContent> = {
	en: {
		title: "Thank you for your order!",
		description: `You will receive a confirmation email with additional details soon. If you have any questions about your order or need to cancel, please contact us: `,
	},
	fr: {
		title: "Thank you for your order!",
		description: `You will receive a confirmation email with additional details soon. If you have any questions about your order or need to cancel, please contact us: `,
	},
	es: {
		title: "Thank you for your order!",
		description: `You will receive a confirmation email with additional details soon. If you have any questions about your order or need to cancel, please contact us: `,
	},
};

/** The thank-you page's entry in the site search index. */
export const PageContent: StaticPageContent = {
	meta: MetaObject,
	content: [ThankYou],
};
